// import styled from 'styled-components';
//
// export const ToListButton = styled.button`
//   position: absolute;
//   bottom: 40px;
//   right: 40px;
//   padding: 12px 20px;
//   background: #6AA6C7;
//   color: white;
//   border: none;
//   border-radius: 5px;
//   cursor: pointer;
//   font-size: 1em;
//   font-weight: 600;
//   transition: all 0.3s ease;
//
//   &:hover {
//     background: #5a96b7;
//   }
//
//   @media (max-width: 768px) {
//     position: fixed;
//     bottom: 20px;
//     right: 20px;
//     left: unset;
//     width: calc(100% - 40px);
//     margin-top: 0;
//     padding: 10px 16px;
//   }
// `;

import styled from 'styled-components';

export const ToListButton = styled.button`
  display: block;
  margin: 20px 0 0 auto; /* отступ сверху 40px, выравнивание по правому краю */
  padding: 12px 20px;
  background: #0A2240;
  color: white;
  border: none;
  //border-radius: 5px;
  cursor: pointer;
  font-size: 1em;
  font-weight: 600;
  transition: all 0.3s ease;
  width: fit-content;

  &:hover {
    background: #6AA6C7;
  }

  @media (max-width: 768px) {
    margin: 20px 10px 0 auto; /* отступ справа 10px на мобилке */
    padding: 10px 16px;
    width: 100%;
  }
`;